import { PagingInfo } from "../../paginator/paging-info.model";
import { CompanyFinancialReports } from "./company-financial-reports.model";

export class CompanyFinancialReportsPageableResult {
  private pagingInfo: PagingInfo;
  private start: number;
  private totalPerPages: number;
  private total: number;
  private data: Array<CompanyFinancialReports>;

  public getPagingInfo(): PagingInfo {
    return this.pagingInfo;
  }

  public setPagingInfo(value: PagingInfo) {
    this.pagingInfo = value;
  }

  public getStart(): number {
    return this.start;
  }

  public getTotalPerPages(): number {
    return this.totalPerPages;
  }

  public getTotal(): number {
    return this.total;
  }

  public getData(): Array<CompanyFinancialReports> {
    return this.data;
  }

  public setStart(value: number) {
    this.start = value;
  }

  public setTotalPerPages(value: number) {
    this.totalPerPages = value;
  }

  public setTotal(value: number) {
    this.total = value;
  }

  public setData(value: Array<CompanyFinancialReports>) {
    this.data = value;
  }

  public addItems(value: Array<CompanyFinancialReports>): void {
    this.data = this.data.concat(value);
  }
}
